<template lang="pug">
div.sub-modal-wrapper.sub-modal-cclone

    header.sub-modal-header
        SectionHeader(:title="modalTitle" :counter="selectedCriteriaCounter")
            template(
                v-if="isCcloneFirstParty"
                slot="subHeader")
                div.subheader
                    div.subheader-info Select 5 to 1000 criteria
            template(
                v-if="isCcloneEvent && eventType === 'negative'"
                slot="subHeader")
                div.subheader
                    div.subheader-info In CClone Mode 3rd Party, default Universe is the Full Database. However, you can define a different Universe.

    div.sub-modal-body(:class="{'content-universe': isCcloneEvent && eventType === 'negative'}")

        div.form-section(v-if="isCcloneEvent && eventType === 'negative'")
            div.section-title Default Universe

            div.default-universe-cartridge
                label.label.flex-1.tree-node__label(for="database") {{ dataBaseChildLabel }}
                input(
                    id="database"
                    name="database"
                    v-model="databaseSelected"
                    :value="true"
                    type="radio")

        div.form-section
            div.section-title(v-if="isCcloneEvent && eventType === 'negative'") Other Universes

            CriteriaList(
                v-if="displayCriteriaList"
                :criteriaList="categories"
                :isCcloneEvent="isCcloneEvent"
                :isCcloneFirstParty="isCcloneFirstParty"
                :firstPartyHistory="firstPartyHistory"
                :ccloneHistory="selectionHistory")

    footer.sub-modal-footer
        div.footer-content.l-flex-row--between
            button.btn.btn--medium.btn--round(@click="closeModal()") Cancel
            button.btn.btn--medium.btn--round.btn-rev(:class="{'ui-disabled': disableValidate}" @click="save()") Validate
</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapMutations, mapGetters } from 'vuex'
import { cloneDeep, get, isEqual, isNil, size } from 'lodash'

import CriteriaList from '@/components/common/CriteriaList.vue'
import SectionHeader from '@/components/common/SectionHeader'

export default {
    name: 'EventsModal',
    components: { CriteriaList, SectionHeader },

    props: {
        ccloneMode: { type: String, required: true },
        isCcloneEvent: { type: Boolean, required: true },
        isCcloneFirstParty: { type: Boolean, required: true },
        displayCriteriaList: { type: Boolean, required: true },
        selectionHistory: { type: Object, required: false, default: () => ({}) },
        firstPartyHistory: { type: Object, required: true }
    },

    watch: {
        databaseSelected: {
            handler: function(newValue, oldValue) {
                if (!isEqual(oldValue, newValue)) {
                    if (!isEqual(this.databaseNegativeEvent, newValue)) {
                        this.setSelectedEvent({ eventType: 'database', event: newValue })
                    }
                    if (newValue) {
                        this.setSelectedEvent({ eventType: 'negative', event: null })
                    }
                }
            }
        },
        negativeEvent: {
            handler: function(newValue) {
                if (!isNil(newValue)) {
                    this.databaseSelected = false
                }
            }
        },
        selectionHistory: {
            handler: function(newValue, oldValue) {
                if (this.eventType === 'negative' && !isEqual(get(newValue, 'database'), get(oldValue, 'database'))) {
                    this.databaseSelected = newValue.database
                }
            },
            deep: true
        },
        displayCriteriaList(val) {
            if (val) {
                this.firstPartyHistoryCopy = cloneDeep(this.firstPartyHistory)
            }
        }
    },

    data() {
        return {
            databaseSelected: !isNil(get(this.selectionHistory, 'database', null)),
            processing: false,
            firstPartyHistoryCopy: cloneDeep(this.firstPartyHistory)
        }
    },

    computed: {
        ...mapGetters('ui/cclone', ['getPositiveEvents', 'getUniverse', 'getFirstPartyCategories', 'getTreeNode']),
        ...mapState('ui/cclone', {
            eventType: state => state.eventType,
            firstPartySelection: state => state.firstPartySelection,
            databaseNegativeEvent: state => state.selectedEvents.database,
            positiveEvent: state => state.selectedEvents.positive,
            negativeEvent: state => state.selectedEvents.negative,
            criteriaTypes: state => state.criteriaTypes
        }),

        modalTitle() {
            return this.isCcloneEvent ? (this.eventType === 'positive' ? `select ${this.eventType} event` : 'Define universe') : 'select 1st party'
        },
        selectedCriteriaCounter() {
            return this.isCcloneFirstParty && size(this.firstPartySelection) ? size(this.firstPartySelection) : 0
        },
        categories() {
            if (this.isCcloneEvent) {
                return this.eventType === 'positive' ? this.getPositiveEvents() : this.getUniverse()
            } else if (this.isCcloneFirstParty) {
                return this.getFirstPartyCategories()
            }
            return []
        },
        dataBaseChildLabel() {
            return this.ccloneMode === '1stParty' ? '1st Party Universe' : 'Full database'
        },
        disableValidate() {
            if (this.processing) {
                return true
            } else if (this.isCcloneEvent) {
                return this.eventType === 'positive' && isNil(this.positiveEvent)
            } else if (this.isCcloneFirstParty) {
                return size(this.firstPartySelection) < 5 || size(this.firstPartySelection) > 1000
            }
            return false
        }
    },
    methods: {
        ...mapMutations('ui/cclone', [
            'setDisplayModal',
            'setSelectedEvent',
            'resetSelectedEventsOnClose',
            'resetSelectedFirstPartyOnClose',
            'setCriteriaType'
        ]),
        closeModal() {
            if (this.isCcloneEvent) {
                this.resetSelectedEventsOnClose({
                    eventType: this.eventType,
                    event: this.selectionHistory
                })
                this.setCriteriaType({ eventType: this.eventType, criteriaType: this.criteriaTypes[this.eventType].previous, history: 'current' })
                this.setCriteriaType({ eventType: this.eventType, criteriaType: null, history: 'previous' })
            } else if (this.isCcloneFirstParty) {
                this.resetSelectedFirstPartyOnClose({
                    firstPartySelection: this.firstPartyHistoryCopy.selection,
                    firstPartySelectAll: this.firstPartyHistoryCopy.selectAll
                })
            }
            this.setDisplayModal({ modal: 'events', isDisplayed: false })
        },
        save() {
            if (this.processing) return // Prevent multiple creation
            this.processing = true
            if (this.isCcloneEvent && this.eventType === 'negative' && !isNil(this.negativeEvent))
                this.setSelectedEvent({ eventType: 'database', event: false })
            this.setDisplayModal({ modal: 'events', isDisplayed: false })
            this.processing = false
        }
    }
}
</script>
